var styles = {"smallPicture":"section-image-wrapper--small-picture","bigPicture":"section-image-wrapper--big-picture","picture":"section-image-wrapper--picture"};

export { styles as default };
//# sourceMappingURL=SectionImageWrapper.module.esm.js.map
